import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import SEOHead from "./components/SEOHead";
import ScrollToTop from "./components/ScrollToTop";
import PageLoader from "./components/PageLoader";
import HomePage from "./pages/HomePage";

const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const SolutionsPage = lazy(() => import("./pages/SolutionsPage"));
const SecurityProductsPage = lazy(() => import("./pages/SecurityProductsPage"));
const ZebraProductsPage = lazy(() => import("./pages/ZebraProductsPage"));
const ZebraCategoryPage = lazy(() => import("./pages/ZebraCategoryPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const ProfessionalServicesPage = lazy(() => import("./pages/ProfessionalServicesPage"));
const ThreatLockerTurkiyePage = lazy(() => import("./pages/ThreatLockerTurkiyePage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-slate-950">
        <BrowserRouter>
          <ScrollToTop />
          <SEOHead />
          <Navbar />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/hizmetler" element={<ServicesPage />} />
              <Route path="/profesyonel-hizmetler" element={<ProfessionalServicesPage />} />
              <Route path="/cozumler" element={<SolutionsPage />} />
              <Route path="/guvenlik-urunleri" element={<SecurityProductsPage />} />
              <Route path="/zebra-urunleri" element={<ZebraProductsPage />} />
              <Route path="/zebra-urunleri/:categoryId" element={<ZebraCategoryPage />} />
              <Route path="/zebra-urunleri/:categoryId/:subcategoryId" element={<ZebraCategoryPage />} />
              <Route path="/iletisim" element={<ContactPage />} />
              <Route path="/threatlocker-turkiye" element={<ThreatLockerTurkiyePage />} />
              <Route path="/gizlilik" element={<PrivacyPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/kullanim-kosullari" element={<TermsPage />} />
              <Route path="/terms" element={<TermsPage />} />
            </Routes>
          </Suspense>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          theme="dark"
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
